import { getUserInitials } from '../helpers/get-user-initials';
import { useCurrentUser } from '../user/use-current-user.query';

export function useCurrentUserInitials() {
  const { data: user } = useCurrentUser();
  return user ? getUserInitials(user) : '';
}
